<template>
    <v-card>
        <v-card-title>
            我的申请
            <v-spacer></v-spacer>
            <router-link style="" to="/">
                <v-img src="../assets/newclose.png"></v-img>
            </router-link>
        </v-card-title>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="搜索"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-actions>
        <v-data-table
                :headers="headers"
                :items="applications"
                :search="search"
                :loading="loading"
                loading-text="正在查询"
                no-data-text="您没有申请记录"
        >
            <template v-slot:item.staus="{ item }">
                {{item.receiveStatus}}
            </template>
            <template v-slot:item.option="{ item }">
                <!--<v-icon @click="printTestApply(item)" class="mr-2">mdi-printer</v-icon>-->
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon v-if="item.receiveStatus === '已申请'" @click="edit(item)" v-on="on" class="mr-2">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>修改记录</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon v-if="item.receiveStatus !== '已申请'" @click="edit(item)" v-on="on" class="mr-2">mdi-eye
                        </v-icon>
                    </template>
                    <span>查看记录</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon @click="report(item)" v-on="on" class="mr-2">mdi-file-document</v-icon>
                    </template>
                    <span>打印报告</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon @click="[dialog = true,deleteTmp = item]" v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>删除记录</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-card-actions>
            <v-spacer></v-spacer>
        </v-card-actions>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="500">
                <v-card>
                    <v-card-title class="headline">提示</v-card-title>
                    <v-card-text>
                        确认删除吗？
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#368FC8" @click="dialog = false">取消</v-btn>
                        <v-btn color="#368FC8" @click="deleteApply(deleteTmp)">确认</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        name: "MyApply",
        inject: ['reload'],
        data: () => ({
            search: '',
            loading: true,
            dialog: false,
            deleteTmp: "",
            baseUrl: window.location.href.substring(0, window.location.href.indexOf('webapp')),
            headers: [
                {
                    text: ' 申请编号',
                    align: 'center',
                    sortable: false,
                    value: 'id',
                },
                {text: '姓名', align: 'center', sortable: false, value: 'name',},
                {text: '性别', align: 'center', sortable: false, value: 'sex'},
                {text: '送检医院', align: 'center', sortable: false, value: 'sendUnitName'},
                {text: '检测项目', align: 'center', sortable: false, value: 'testTypeNames'},
                {text: '申请时间', align: 'center', value: 'createTime'},
                {text: '状态', align: 'center', sortable: false, value: 'staus'},
                {text: '操作', align: 'center', sortable: false, value: 'option'},
            ],
            applications: []
        }),
        mounted() {
            if (!this.$store.state.landing) {
                this.$snackbar.info('请登录后操作');
                this.$router.push({path: '/login'});
            } else {
                this.getList();
            }
        },
        methods: {
            closePage() {
                this.$router.push({path: '/'});
            },
            getList() {
                this.$axios.get('/testapply/list').then((response) => {
                    if (response.data.success) {
                        this.applications = response.data.data;
                        this.applications.forEach(n => {
                            if (n.reportStatus) {
                                switch (n.reportStatus) {
                                    case '1':
                                        n.receiveStatus = '已生成';
                                        break;
                                    case '2':
                                        n.receiveStatus = '已复核';
                                        break;
                                    case '3':
                                        n.receiveStatus = '已签发';
                                        break;
                                }
                            } else if (n.receiveStatus > 0) {
                                n.receiveStatus = '已接收';
                            } else {
                                n.receiveStatus = '已申请';
                            }
                        });

                        this.$snackbar.info(response.data.content);
                        this.loading = false
                    } else {
                        this.$snackbar.info(response.data.content);
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                });
            },
            edit(item) {
                if (item.receiveStatus !== '已申请') {
                    this.$snackbar.info('该标本已接收，不可更改');
                }
                switch (item.type) {
                    case '1':
                        this.$router.push({path: '/genetestapply', query: {id: item.id}});
                        break;
                    case '2':
                        this.$router.push({path: '/immunohematologytestapply', query: {id: item.id}});
                        break;
                    case '3':
                        this.$router.push({path: '/paternitytest', query: {id: item.id}});
                        break;
                    case '4':
                        this.$router.push({path: '/specialplatelettestapply', query: {id: item.id}});
                        break;
                }
            },
            deleteApply(item) {
                this.$axios.post('/testapply/delete', item).then((response) => {
                    if (response.data.success) {
                        this.$snackbar.info(response.data.content);
                        this.reload();
                        this.overlay = false;
                    } else {
                        this.$snackbar.info(response.data.content);
                        this.overlay = false;
                        this.dialog = false;
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                    this.overlay = false;
                });
            },
            printTestApply(item) {
                window.open(this.baseUrl + 'testapply/print/' + item.type + '/testapply.html?id=' + item.id + '&targetsystem=unicorn');
            },
            report(item) {
                let me = this;
                if (item.receiveStatus !== '已签发') {
                    this.$snackbar.info('该申请记录未生成报告');
                    this.overlay = false;
                    return;
                }
                this.$axios.get('/testapply/reportid', {
                    params: {
                        id: item.id
                    }
                }).then((response) => {
                    if (response.data.success) {
                        let data = response.data.data;
                        if (data.length > 0) {
                            for (let i = 0; i < data.length; i++) {
                                window.open(me.baseUrl + 'reportsearch/print/' + data[i].reportType + '/report.html?id=' + data[i].id + '&channel=4' + '&print=true'+ '&targetsystem=unicorn');
                            }
                        }else {
                            this.$snackbar.info("无法查看该报告！");
                        }
                    } else {
                        this.$snackbar.info(response.data.content);
                        this.overlay = false;
                        this.dialog = false;
                    }
                }).catch(() => {
                    this.$snackbar.info('连接服务器失败');
                    this.overlay = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>